module.exports = __webpack_public_path__ + "213934d8.svg";